import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { BaseIcon } from '../BaseIcon';
export const SelectMark = ({ height = '10px', stroke, viewbox = '0 0 10 10', width = '10px', strokeWidth = 1.1, ...rest }) => {
    const { color } = useTheme();
    return (_jsx(BaseIcon, { height, width, viewBox: viewbox, ...rest, children: _jsxs("g", { stroke: stroke || color.deprecated.black.primary, strokeWidth: strokeWidth, children: [_jsx("path", { className: 'p1', d: 'M8.695 1.095l-7.6 7.6', strokeWidth: strokeWidth }), _jsx("path", { className: 'p2', d: 'M8.695 8.695l-7.6-7.6', strokeWidth: strokeWidth })] }) }));
};
//# sourceMappingURL=SelectMark.js.map